export default __webpack_public_path__ + "static/media/certification.dfc81548.ico";